// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Roboto';
}

::-webkit-scrollbar {
  width: 5px;
}

/* / Track / */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
 
/* / Handle / */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* / Handle on hover / */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

 
::-webkit-scrollbar:horizontal{
  height: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;;AAGA;EACE,WAAW;AACb","sourcesContent":["body {\n  font-family: 'Roboto';\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* / Track / */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n \n/* / Handle / */\n::-webkit-scrollbar-thumb {\n  background: #888; \n}\n\n/* / Handle on hover / */\n::-webkit-scrollbar-thumb:hover {\n  background: #555; \n}\n\n \n::-webkit-scrollbar:horizontal{\n  height: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
